import { LayoutVariant } from './LayoutVariant';

/* ORIGINAL Layouts -  different layout based on item count */
/*
export const LIST_LAYOUTS: Array<LayoutVariant[]> = [
  [],
  [LayoutVariant.FULL],
  [LayoutVariant.WIDE, LayoutVariant.SMALL],
  [LayoutVariant.SMALL, LayoutVariant.SMALL, LayoutVariant.SMALL],
  [LayoutVariant.FULL, LayoutVariant.SMALL, LayoutVariant.SMALL, LayoutVariant.SMALL],
  [LayoutVariant.BIG, LayoutVariant.BIG, LayoutVariant.SMALL, LayoutVariant.SMALL, LayoutVariant.SMALL],
  [
    LayoutVariant.BIG,
    LayoutVariant.BIG,
    LayoutVariant.WIDE,
    LayoutVariant.SMALL,
    LayoutVariant.SMALL,
    LayoutVariant.WIDE,
  ],
  [
    LayoutVariant.BIG,
    LayoutVariant.BIG,
    LayoutVariant.SMALL,
    LayoutVariant.SMALL,
    LayoutVariant.SMALL,
    LayoutVariant.WIDE,
    LayoutVariant.SMALL,
  ],
];
*/

export const LIST_LAYOUT: LayoutVariant[] = [
  LayoutVariant.FULL,
  LayoutVariant.BIG,
  LayoutVariant.BIG,
  LayoutVariant.WIDE,
  LayoutVariant.SMALL,
  LayoutVariant.SMALL,
  LayoutVariant.SMALL,
  LayoutVariant.SMALL,
];
